module.exports = __webpack_public_path__ + "static/media/hazmat.c213317d.png";